import { ReactElement } from "react";

import { CSSObject } from "@emotion/react";
import { Anchor } from "@newsela/angelou";
import { isEmpty, last } from "@s-libs/micro-dash";

import { cellLinkCss } from "../Cells.style";

interface CellLinkListProp {
  value?: string[];
  href?: string;
  label: string;
  __css?: CSSObject;
}

const CellLinkList = ({
  value,
  label,
  href,
  __css = {},
}: CellLinkListProp): ReactElement => {
  const sanitized = value?.filter((val) => !isEmpty(val));
  const valueCount = sanitized ? sanitized.length : 0;
  const hasValues = valueCount > 0;
  const hasSingleValue = valueCount === 1;
  const linkListLabel =
    hasSingleValue && sanitized ? last(sanitized) : `${valueCount} ${label}`;

  return hasValues && href ? (
    <Anchor href={href} __cssFor={{ root: [...cellLinkCss, __css] }}>
      {linkListLabel}
    </Anchor>
  ) : (
    <span data-testid="list-text">{linkListLabel}</span>
  );
};

export default CellLinkList;
